<template>
  <div class="c-table" ref="policyTable">
    <!-- <Spin size="large" fix v-if="loading"></Spin> -->
    <el-table
      class="common-el-table-styles"
      ref="table"
      :data="data"
      :height="height"
      v-loading="loading"
      border
      stripe
      @sort-change="sortChange"
    >
      <el-table-column
        v-for="(col, id) in columns"
        :key="id"
        :prop="col.key"
        :label="col.title"
        :fixed="col.fixed"
        :show-overflow-tooltip="col.overflow"
        :min-width="col.width"
        :align="col.align"
        :sortable="col.sortable"
        :sort-orders="['descending', 'ascending', null]"
      >
        <template slot-scope="scope">
          <span v-if="col.key === 'convertIndex'">{{ getConvertType(scope.row[col.key]) }}</span>
          <span v-else-if="['createTime', 'updateTime'].includes(col.key)">{{ scope.row[col.key] | datetimeToSec }}</span>
          <div v-else-if="col.key === 'control'">
            <Poptip confirm transfer title="您确认删除该策略模板吗？" @on-ok="$emit('on-del', scope.row)">
              <el-button type="text" size="small">删除</el-button>
            </Poptip>
            <el-button type="text" size="small" @click="copyClick(scope.row)">&ensp;复制</el-button>
            <el-button type="text" size="small" @click="editClick(scope.row)">&ensp;修改</el-button>
          </div>
          <span v-else-if="col.key === 'cpa_bid'"
            >{{ getBidValue(scope.row) }}<br v-if="getBidValue(scope.row)" />{{ getCpaBidType(scope.row) }}</span
          >
          <span v-else-if="col.key === 'deep_cpabid'"
            >{{ getDeepBidValue(scope.row) }}<br v-if="getDeepBidValue(scope.row)" />{{ getDeepCpaBidType(scope.row) }}</span
          >
          <span v-else>{{ scope.row[col.key] }}</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import { timeout } from '@/common/js/utils'
import convertData from '@/data/toutiao/convert_data'

export default {
  name: 'policyTable',
  props: {
    data: {
      type: Array,
      default() {
        return []
      }
    },
    loading: {
      type: Boolean,
      default() {
        return false
      }
    },
    columns: {
      type: Array
    },
    summary: {
      type: Object
    },
    type: {
      type: String
    },
    height: {
      type: Number
    }
  },
  methods: {
    sortChange(column) {
      let orderName
      if (column.order === 'ascending') orderName = 'asc'
      else if (column.order === 'descending') orderName = 'desc'
      this.$emit('on-sort', { sort: column.prop, order: orderName })
    },
    editClick(row) {
      const { id } = row
      this.$router.push({ name: 'policiesadd', query: { id, t: 'edit' } })
    },
    copyClick(row) {
      const { id } = row
      this.$router.push({ name: 'policiesadd', query: { id } })
    },
    getBidValue(row) {
      if (row.smart_bid_type === '手动出价') {
        // SMART_BID_CUSTOM
        if (row.bid_range === 0) {
          // 固定金额
          return row.cpa_bid
        } else if (row.bid_range === 1) {
          // 随机金额
          return row.bid_num_range.join('~')
        }
      } else if (row.smart_bid_type === '自动出价') {
        // SMART_BID_CONSERVATIVE
        if (row.bid_range === 0) {
          // 固定金额
          return row.cpa_bid
        } else if (row.bid_range === 1) {
          // 随机金额
          return row.bid_num_range.join('~')
        }
      }
    },
    getCpaBidType(row) {
      if (row.smart_bid_type === '自动出价') {
        return row.adjust_cpa === 1 ? '期望出价' : row.adjust_cpa === 0 ? '系统推荐' : '换行测试'
      } else return ''
    },
    getDeepBidValue(row) {
      if (row.deep_bid_type === 'DEEP_BID_DEFAULT') {
        // 无深度优化
        return '——'
      } else if (row.deep_bid_type === 'DEEP_BID_PACING' || row.deep_bid_type === 'SMARTBID') {
        // 自动优化
        return '自动优化'
      } else if (row.deep_bid_type === 'DEEP_BID_MIN' || row.deep_bid_type === 'AUTO_MIN_SECOND_STAGE') {
        // 自定义双出价
        if (row.deep_cpabid_range === 0) {
          // 固定金额
          return row.deep_cpabid
        } else if (row.bid_range === 1) {
          // 随机金额
          return row.deep_cpabid_num_range.join('~')
        }
      } else if (row.deep_bid_type === 'ROI_COEFFICIENT') {
        // ROI系数
        return row.roi_goal
      }
    },
    getDeepCpaBidType(row) {
      if (row.deep_bid_type === 'DEEP_BID_MIN' || row.deep_bid_type === 'AUTO_MIN_SECOND_STAGE') return '双出价'
      else if (row.deep_bid_type === 'ROI_COEFFICIENT') return 'ROI系数'
    },
    getConvertType(val) {
      const convert = this.convertData.filter((ret) => ret.key === val).pop()
      if (convert) return convert.value
      return '——'
    }
  },
  data() {
    return {
      convertData: convertData
    }
  }
}
</script>
